import InitApi from "api/InitApi";
import { useQuery } from "react-query";
import useTokenStore from "store/tokenStore";
import { deleteEmptyObjects, fetchConfig } from "utils";

const useFetchWeeklyRegistrationsGraph = (queryParams) => {
	const { accessToken } = useTokenStore();

	const fetch = async () => {
		const instance = await InitApi({ accessToken });
		const params = queryParams ? deleteEmptyObjects(queryParams) : null;
		const res = await instance.get("weekly-registrations-graph", {
			params: { ...params },
		});
		return res.data;
	};

	return useQuery(["weekly-registrations-graph", queryParams], () => fetch(), {
		...fetchConfig,
	});
};

export default useFetchWeeklyRegistrationsGraph;
